import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectParkingCheckboxFilter } from 'shared/selectors/advancedFilters';
import { ALL_PARKING_TYPES } from '../../../../../../../packages/JsonQuery';

export const ParkingCheckboxContainer: FC = () => {
  const { label, checked } = useSelector(selectParkingCheckboxFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, isChecked: boolean) => {
      onChange({ action: 'setParkingType', arguments: [isChecked ? ALL_PARKING_TYPES : null] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <Checkbox label="Есть парковка" checked={checked} onChange={handleChange} />
    </AdvancedFilterRow>
  );
};
